import { model as i18nModel } from '!/i18n'
import { register } from '!/repository'
import { api } from '@setplex/tria-api'
import { combine, createEvent, sample, type Store } from 'effector'
import { not } from 'patronum'
import { model as popupModel } from '~/entities/info-popup'
import { model as movieModel } from '~/entities/movies'
import { model as paymentModel } from '~/features/payment/generic'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import * as pinLockFeature from '~/features/pin-lock'
import { type VodRecommendedWithPrice } from '~/shared/interfaces'
import { extendMediaItemByLabelPrice } from '~/shared/tools'
import { type MovieCategoryWithRecommendedFormatted } from './index.h'

export const init = createEvent<{
  vodId: string
  categoryId: number
  vodIndex?: number
  query: URLSearchParams
}>()

export const left = createEvent<{
  vodId: number
}>()

sample({
  clock: init,
  filter: not(api.vods.getVodFx.pending),
  fn: ({ vodId }) => ({ page: 0, vodId: Number(vodId) }),
  target: api.vods.getVodFx,
})

sample({
  clock: api.vods.updateContinueWatchingFx.done,
  source: init,
  filter: not(api.vods.updateContinueWatchingFx.pending),
  fn: ({ vodId }) => ({ page: 0, vodId: Number(vodId) }),
  target: api.vods.getVodFx,
})

sample({
  clock: init,
  filter: not(api.vods.getRecommendedVodsFx.pending),
  fn: ({ vodId, query }) => ({
    vodId: Number(vodId),
    categoryId: Number(query.get('categoryId') || 0),
    vodIndex: query.has('showIndex')
      ? Number(query.get('showIndex'))
      : undefined,
  }),
  target: api.vods.getRecommendedVodsFx,
})

export const $movieCategoryWithRecommendedFormatted: Store<MovieCategoryWithRecommendedFormatted | null> =
  combine(
    api.vods.$movieCategoryWithRecommended,
    ssePurchasesModel.$vod,
    i18nModel.$t,
    (category, adjust) => {
      if (category) {
        return {
          ...category,
          content: category?.content.map((vod) =>
            extendMediaItemByLabelPrice(adjust(vod))
          ) as VodRecommendedWithPrice[],
        }
      }
      return category
    }
  )

//
// Unlock pin locked movie
//

const unlock = createEvent()

sample({
  clock: unlock,
  source: movieModel.$vodFormatted,
  filter: Boolean,
  fn: ({ id, name, locked }) =>
    ({
      ...pinLockFeature.emptyPinLockState,
      id,
      name,
      locked,
    }) as pinLockFeature.IPinLockPopupProps,
  target: pinLockFeature.openPinLockPopup,
})

//
//
//

// clear store
api.vods.$vod.reset(init)

sample({
  clock: init,
  target: popupModel.closeInfoPopup,
})

register(movieModel.$vodFormatted, '$vodFormatted')
register(
  $movieCategoryWithRecommendedFormatted,
  '$movieCategoryWithRecommended'
)
register(movieModel.updateVod, 'updateVod')
register(paymentModel.selectMoviePaymentButton, 'selectMoviePaymentButton')
register(unlock, 'routes/movies/details/unlock')
